import * as chartActionTypes from '../../constants/chart-action-types';
import * as utils from './highcharts.utils';

const initialState = {};

function highChartsReducer(state = initialState, action) {
  const { id, highchart } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case utils.UPDATE_HIGHCHARTS:
      return utils.update(state, id, highchart);
    default:
      return state;
  }
}

export default highChartsReducer;
